import * as React from 'react';
import { ComponentProps, FC } from 'react';
import BaseErrorBlock from '../Base/BaseErrorBlock';
type BaseErrorBlockProps = ComponentProps<typeof BaseErrorBlock>

interface UseErrorBlockProps extends BaseErrorBlockProps {
}
const UseErrorBlock: FC<UseErrorBlockProps> = (props) => {
  const { ...restProps } = props;
  return (
    <BaseErrorBlock {...restProps} />
  )
};

export default UseErrorBlock;
